<div fxLayoutAlign="center center">
  <form fxFlex="1 1 60%;" #fUpdateUsrName="ngForm" (ngSubmit)="onUpdateInfo(fUpdateUsrName.value)"
        role="submit">
    <mat-card fxFlex>
      <mat-card-header fxLayoutAlign="space-between center" style="padding-bottom: 16px;">
        <mat-card-title fxLayoutGap="10px" role="heading" aria-level="1">Update User Name</mat-card-title>
      </mat-card-header>
      <mat-card-content fxLayout="column" fxLayoutAlign="center" fxLayoutGap="10px grid">
        <mat-form-field floatLabel="always" appearance="outline">
          <mat-label>New Email</mat-label>
          <input matInput name="email" #newEmail="ngModel" required type="email" [(ngModel)]="email"
                 appEmailExist autocomplete="doNotAutoComplete">
          <button mat-icon-button *ngIf="newEmail" matSuffix aria-label="Clear" (click)="email=undefined">
            <mat-icon>close</mat-icon>
          </button>
          <mat-error *ngIf="newEmail.errors?.['exists']">
            Email "{{newEmail.value}}" is already in use
          </mat-error>
        </mat-form-field>
        <mat-form-field fxFlex="50%" floatLabel="always" appearance="outline">
          <mat-label>Current Password</mat-label>
          <input matInput name="old_Password" #old_Password="ngModel" required type="password" [(ngModel)]="oldPassword"
                 [appValidatePassword]="'/user/validate-old-password'" autocomplete="off">
          <button mat-icon-button *ngIf="oldPassword" matSuffix aria-label="Clear" (click)="oldPassword=undefined">
            <mat-icon>close</mat-icon>
          </button>
          <div *ngIf="old_Password.invalid && (old_Password.dirty || old_Password.touched)">
            <mat-error *ngIf="old_Password.errors?.['passwordInValid']">
              Invalid Current Password
            </mat-error>
          </div>
        </mat-form-field>
      </mat-card-content>
      <mat-card-actions fxLayout="row" fxLayoutAlign="center" fxLayoutGap="5px">
        <button color="primary" mat-raised-button type="submit" [disabled]="fUpdateUsrName.invalid || !fUpdateUsrName.dirty|| isLoading">Update
          Info</button>
        <button mat-raised-button color="warn" mat-raised-button type="reset" (click)="fUpdateUsrName.reset()">Cancel</button>
      </mat-card-actions>
    </mat-card>
  </form>
</div>
